import { FeatureFlags } from '@/modules/featureFlags';

import { useFeatureFlag } from './useFeatureFlag';

export const useIsApplyUnmatchedPushAvailable = (): boolean =>
  useFeatureFlag(FeatureFlags.APPLY_UNMATCHED_PUSH);
